import { render } from "./materialdesign.vue?vue&type=template&id=0b5a0dae"
import script from "./materialdesign.vue?vue&type=script&lang=js"
export * from "./materialdesign.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__